import type { AdminRole } from '@/lib/api-admin';

/**
 * ID55 수기주문 등록 RBAC.
 *
 * be-manual-order 계약: `BackofficeManualOrderController` 가
 * `@PreAuthorize("hasAnyRole('OPS_ADMIN','CS_AGENT','SUPER_ADMIN')")`.
 * 전화 주문·B2B 대량주문을 운영/CS 가 직접 등록하는 경로.
 */
export const MANUAL_ORDER_WRITE_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'CS_AGENT',
];
